import React from "react";
import styled from "styled-components";
import { formatCurrency } from "utils/string";
import { colors } from "utils/theme";

const getValueColor = ({ $value }) => {
  if ($value > 0) {
    return colors.azure;
  }

  if ($value < 0) {
    return colors.cerise;
  }

  return colors.dust;
};

const Wrapper = styled.div<{ $value: number }>`
  font-size: 24px;

  color: ${getValueColor};
`;

interface Props {
  value: number;
  isCurrency?: boolean;
}

const ValueWithColor: React.FC<Props> = ({ value, isCurrency }) => {
  const displayValue = isCurrency ? formatCurrency(value, true) : value;
  return <Wrapper $value={value}>{displayValue}</Wrapper>;
};

export default ValueWithColor;
